import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import VueSmoothScroll from 'vue2-smooth-scroll'
import 'buefy/dist/buefy.css'

Vue.use(Buefy)
Vue.use(VueSmoothScroll)
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
